const l1Categories = [
  {
    id: "1",
    displayName: "Fees",
    slug: "fees",
    l2Categories: [
      {
        slug: "annual_fee",
        displayName: "Annual Fee",
      },
      {
        slug: "maintenance_fee",
        displayName: "Maintenance Fee / Monthly Service Fee",
      },
      {
        slug: "atm_fee",
        displayName: "ATM Fee",
      },
      {
        slug: "wire_transfer_fee",
        displayName: "Wire Transfer Fee",
      },
      {
        slug: "late_fee",
        displayName: "Late Fee",
      },
      {
        slug: "overdraft_fee",
        displayName: "Overdraft Fee",
      },
    ],
  },
  {
    id: "2",
    displayName: "Fraud / Unauthorized Activity",
    slug: "fraud_unauthorized_activity",
    l2Categories: [
      {
        slug: "unauthorized_activity",
        displayName: "Unauthorized Activity",
      },
      {
        slug: "authorized_activity",
        displayName: "Authorized Activity",
      },
      {
        slug: "card_lost_or_stolen",
        displayName: "Card Lost / Stolen",
      },
    ],
  },
  {
    id: "3",
    displayName: "Employee Behavior",
    slug: "employee_behavior",
    l2Categories: [
      {
        slug: "unauthorized_account_opening",
        displayName: "Unauthorized Account Opening",
      },
      {
        slug: "unauthorized_changes_to_account",
        displayName: "Unauthorized Changes to Account",
      },
    ],
  },
  {
    id: "4",
    displayName: "Digital",
    slug: "digital",
    l2Categories: [
      {
        slug: "login_issue",
        displayName: "Login Issue",
      },
      // {
      //   slug: "authorized_activity",
      //   displayName: "Authorized Activity",
      // },
      {
        slug: "feature_usability",
        displayName: "Feature Usability",
      },
    ],
  },
];

export default l1Categories;
